import { useMemo } from 'react';

import { buildNormalizedPlateToInternalIdMap } from '../utils/deviceInternalIdLookup';
import useDevices from './devices';

/** Normalized license plate → device internal_id from the cached fleet device list. */
const useVehicleInternalIdByPlate = (): Map<string, string | number> => {
    const { devices } = useDevices();
    return useMemo(() => buildNormalizedPlateToInternalIdMap(devices.map((d) => d.device)), [devices]);
};

export default useVehicleInternalIdByPlate;
